import React, { memo, useCallback } from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { useAppSelector } from 'store/hooks';
import { hitSlop, rem } from 'design-system';
import { IconBell } from 'design-system/icons';
import useColors from 'hooks/useColors';
import { selectCreditAlertsUnreadCount, selectIsCreditScoreAlertsAvailable, selectShouldShowCreditScoreBellIcon, } from 'features/credit-score/selectors';
import NotificationCount from 'features/notifications/components/NotificationCount';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { isWeb } from '../../../constants';
const customHitSlop = {
    ...hitSlop,
    left: rem(6),
    right: rem(6),
};
const BorrowHeaderRight = () => {
    const nav = useMainStackNavigation();
    const colors = useColors();
    const isAlertsAvailable = useAppSelector(selectIsCreditScoreAlertsAvailable);
    const shouldShowCreditScoreBellIcon = useAppSelector(selectShouldShowCreditScoreBellIcon);
    const unreadCount = useAppSelector(selectCreditAlertsUnreadCount);
    const onPress = useCallback(() => {
        nav.navigate('CreditScoreAlertsScreen');
    }, [nav]);
    if (!isAlertsAvailable || !shouldShowCreditScoreBellIcon) {
        return null;
    }
    return (<View style={[styles.row, isWeb && styles.webPadding]}>
      <TouchableOpacity onPress={onPress} hitSlop={customHitSlop} accessibilityHint="Credit alerts">
        <IconBell color={colors.elements.primary}/>
        <NotificationCount top={0} left={unreadCount > 999 ? rem(6) : rem(10)} count={unreadCount}/>
      </TouchableOpacity>
    </View>);
};
const styles = StyleSheet.create({
    row: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
        paddingRight: rem(16),
    },
    webPadding: {
        paddingRight: rem(16) + 7.5,
        paddingTop: rem(4),
    },
});
export default memo(BorrowHeaderRight);
